import TechStacks from "./TechStacks";

const TechStackGroup = ({ data, widthAndheight, gap, isLong, classname }) => {
  const isLongList = isLong || data?.length > 4;

  return (
    <div
      className={`${gap ? gap : "gap-4"} ${
        isLongList ? "flex-wrap justify-center" : ""
      } relative flex  mx-auto mb-2 max-w-max-profile-content-width ${classname}`}
    >
      {data?.map((value) => (
        <TechStacks
          key={value?.index}
          value={value || value?.value}
          widthAndheight={widthAndheight}
          isLongList={isLongList}
        />
      ))}
    </div>
  );
};

export { TechStackGroup };
export default TechStackGroup;
